import type { RoundEvent } from '@flip7/shared';

export function formatRoundEvent(event: RoundEvent): string {
  switch (event.type) {
    case 'freeze':
      return `${event.playerName} froze ${event.targetName}`;
    case 'second-chance':
      return event.playerName === event.targetName
        ? `${event.playerName} got a Second Chance`
        : `${event.playerName} gave Second Chance to ${event.targetName}`;
    case 'flip-three':
      return event.playerName === event.targetName
        ? `${event.playerName} Flip Three'd themselves`
        : `${event.playerName} Flip Three'd ${event.targetName}`;
    case 'bust':
      return event.card?.type === 'number'
        ? `${event.playerName} busted (drew ${event.card.value})`
        : `${event.playerName} busted`;
    case 'stay':
      return `${event.playerName} settled`;
    case 'second-chance-save':
      return event.card?.type === 'number'
        ? `${event.playerName} saved by Second Chance (drew ${event.card.value})`
        : `${event.playerName} saved by Second Chance`;
    default:
      return '';
  }
}

export function eventIcon(type: RoundEvent['type']): string {
  switch (type) {
    case 'freeze': return '\u2744\uFE0F';
    case 'second-chance': return '\uD83D\uDEE1\uFE0F';
    case 'second-chance-save': return '\u2728';
    case 'flip-three': return '\uD83C\uDCCF';
    case 'bust': return '\uD83D\uDCA5';
    case 'stay': return '\u2705';
    default: return '';
  }
}

export function eventColor(type: RoundEvent['type']): string {
  switch (type) {
    case 'freeze': return '#0288D1';
    case 'second-chance': case 'second-chance-save': return '#7B1FA2';
    case 'flip-three': return '#DAA520';
    case 'bust': return '#D32F2F';
    case 'stay': return '#2E7D32';
    default: return '#666';
  }
}
